import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { InteractiveFormComponent } from "../../components/interactive-form/interactive-form.component";
import { InteractiveFormSubmit } from "../../models/interactive-form.model";
import { injectCreateInteractive } from "../inject-create-interactive";

@Component({
    selector: "app-create-interactive",
    templateUrl: "./create-interactive.component.html",
    styleUrl: "./create-interactive.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterLink, InteractiveFormComponent]
})
export class CreateInteractiveComponent {
    private readonly createInteractive = injectCreateInteractive("We couldn’t save your changes. Try again.");

    readonly submitting = this.createInteractive.submitting;

    onSubmit(event: InteractiveFormSubmit): void {
        this.createInteractive.submit(event);
    }
}
